angular.module('Itao.IndicatorMap').directive('districtSearch', function (mapConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'districtSearch.html',
    restrict: 'E',
    scope: {
      districts: '=',
      showResults: '='
    },

    link: function (scope) {
      scope.language = mapConfig.language;
      scope.translations = mapConfig.translations;
      scope.friends = [
        {name: 'Peter', age: 20},
        {name: 'Pablo', age: 55},
        {name: 'Linda', age: 20},
        {name: 'Marta', age: 37},
        {name: 'Othello', age: 20},
        {name: 'Markus', age: 32}
      ];

      scope.filterFunction = function (element) {
        return element.name.match(/^Ma/) ? true : false;
      };
    }
  };
});
